<template>
  <div id='paymentpx'>
       <NavTop title='选择支付方式' :islink='true' linkurl='/index'/>
       <div class="timecon">
           <div class="money row"><span class="money-symb">¥</span><span class="money-digit">{{showmoney}}</span></div>
           <div class="countdown row">
            支付剩余时间 <span>{{timetag}}</span>
           </div>
           <div class="tips row">
            请在30分钟内培训费用，超时未付款将自动取消
           </div>
       </div>
       <van-radio-group v-model="type">
        <van-cell-group>
            <van-cell title="微信支付" clickable @click="type = '2'" title-class="title" value-class="value">
                    <template #title>
                        <Icon src='wechat'  class='payicon'/>
                        <span class='paywords'>微信支付</span>
                    </template> 
                    <template #right-icon>
                        <van-radio name="2" checked-color="#07C160"/>
                    </template>
            </van-cell>
            <van-cell clickable @click="type = '1'" title-class="title" value-class="value">
                    <template #title>
                        <Icon src='alipay' class='payicon'/>
                        <span class='paywords'>支付宝</span>
                    </template>    
                    <template #right-icon>
                        <van-radio name="1" checked-color="#07C160"/>
                    </template>
            </van-cell>
        </van-cell-group>
       </van-radio-group>
       <van-submit-bar :price="realmoney*100" >
            <template #button>
               <div class="bottomcon-btn-cancel" @click="onCancel">取消订单</div>
               <div class="bottomcon-btn-sure" @click="onSubmit">去付款</div>
            </template>
       </van-submit-bar>     
  </div>
</template>
<script>
import {RadioGroup, Radio ,Cell, CellGroup,SubmitBar } from 'vant'
import NavTop from '@/components/navtop'
import Icon from '@/components/icon'

export default {
   name: 'paymentpx',
   data() {
        return {
          type:'2',
          showmoney:'',
          realmoney:0,
          lefttime:0,
          timetag:'',
          processing:false
        };
   }, 
   created(){
        this.getList(); 
   },
   methods: {
      getList(){
          this.$post('/school/getTrainOrder',{orderid:this.$route.params.orderid}).then((data)=>{
              if(data.result.success){
                   this.lefttime=parseInt(data.result.info.lefttime)
                   if(this.lefttime<=0){
                        this.onCancel()
                   }else{
                        this.realmoney=Number(data.result.info.fee)
                        if(Number.isInteger(this.realmoney)){
                            this.showmoney=this.realmoney+'.00'
                        }else{
                            this.showmoney=this.realmoney
                        }
                        this.displayTime()
                   }
              }
          })
      },
      displayTime(){
         if(this.lefttime>0){
            this.showTime()
         }
      },
      showTime(){
            this.lefttime-=1
            let mm = Math.floor(this.lefttime / 60);
            let ss = Math.floor(this.lefttime % 60);
            if(mm<10){
            mm='0'+mm
            }
            if(ss<10){
            ss='0'+ss
            }
            this.timetag=mm+":"+ss
            
            if(mm=="00"&&ss=="00"){
                this.onCancel()
            }else{
                setTimeout(()=>{this.showTime()},1000)
            }
      },
      onSubmit(){
          if(this.processing){
              this.$toast('请等待交易完成')
              return false
          }

          let payUrl=''
          if(this.type=='1'){
              payUrl='/alipay/paypx'    
          }else if(this.type=='2'){
              payUrl='/wechatpay/paypx'  
          }
          if(payUrl==''){
            this.$toast("支付选择有误")
            return false
          }
          this.processing=true
          this.$post(payUrl,{orderid:this.$route.params.orderid}).then((data)=>{
              this.processing=false
              if(data.result.success){
                  document.write(data.result.info)
              }else{
                  this.$toast(data.result.info)
              }
          })
      },
      onCancel(){
          this.$go("/trainlist")
      }
   },
   components: {
        [RadioGroup.name]:RadioGroup,
        [Radio.name]:Radio,
        [Cell.name]:Cell,
        [CellGroup.name]:CellGroup,
        [SubmitBar.name]:SubmitBar,
        Icon,
        NavTop
   }
}
</script>
<style scoped>
#paymentpx{background-color:#F6F6F6;min-height: 100vh;;z-index:999;}
.title{display: flex;align-items: center;}
.value{display: flex;align-items: center;}
.payicon{width:0.6rem;height:0.6rem;}
.paywords{padding: 0.1rem;}
.bottomcon-btn-cancel{background-color:#ccc;color:#333;height:1rem;width:2rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;margin-right: 0.1rem;}
.bottomcon-btn-sure{background-color:#ee0a24;color:#fff;height:1rem;width:2rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;}
.timecon{display: flex;flex-flow: column nowrap;background-color: #fff;border-radius: 0.25rem;padding: 0.25rem;margin: 0 0.2rem;}
.money{font-size:0.35rem;color:#333;display: flex;align-items: center;justify-content: center;}
.countdown{color:#333;font-size:0.35rem;}
.tips{color:#444;font-size:0.34rem;font-weight: 600;}
::v-deep .van-radio-group {margin-top:0.35rem;}
.row{padding: 0.1rem;}
.money-symb{font-size:0.6rem;padding:0.15rem}
.money-digit{font-size:0.80rem}
</style>